import { schema } from 'normalizr';
import { Product } from '../interfaces';

const address = new schema.Entity('addresses');
const shippingMethod = new schema.Entity('shippingMethods');
const giftCardTheme = new schema.Entity('giftCardThemes');
const retailer = new schema.Entity('retailers', {
  address,
  shippingMethods: [shippingMethod],
});

export const productSchema = new schema.Entity<Array<Product>>('products', {
  giftCardTheme,
  variants: [{ retailers: [{ retailer, shippingMethod }] }],
});
